import { typography } from 'styles/typography'

const themeStyles = colors => {
  const styles = {
    container: {
      borderTop: `1px solid ${colors.silverGray}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    text: {
      ...typography.font,
      color: colors.approxBlack,
      fontSize: 12,
      letterSpacing: 0,
      lineHeight: '16px',
      textAlign: 'center',
      margin: '25px 0'
    },
    link: { color: colors.primary }
  }
  return styles
}

export default themeStyles
